import imageCompression from "browser-image-compression";

const RESIZE_OPTIONS = {
	width: 2560,
	height: 1440,
};

const COMPRESSION_OPTIONS = {
	maxSizeMB: 10,
	useWebWorker: true
};

export async function compress(image: Blob): Promise<File> {
	const file = asFile(image);

	const resized = await resizeImage(file);
	if (resized.size < COMPRESSION_OPTIONS.maxSizeMB * 1024 * 1024) {
		return Promise.resolve(resized);
	}

	return imageCompression(resized, COMPRESSION_OPTIONS);
}

async function resizeImage(image: File): Promise<File> {
	const original: ImageBitmap = await createImageBitmap(image);

	const widthRatio = original.width / RESIZE_OPTIONS.width;
	const heightRatio = original.height / RESIZE_OPTIONS.height;
	const ratio = Math.max(widthRatio, heightRatio);

	if (ratio <= 1) {
		return Promise.resolve(image);
	}

	const resizeWidth = original.width / ratio;
	const resizeHeight = original.height / ratio;

	return new Promise(resolve => {
		const canvas = document.createElement("canvas");
		const ctx = canvas.getContext("2d");

		if (ctx == null) {
			return resolve(image);
		}

		canvas.width = resizeWidth;
		canvas.height = resizeHeight;


		createImageBitmap(image, { resizeWidth, resizeHeight }).then(
			(bitmap: ImageBitmap) => {
				ctx.drawImage(bitmap, 0, 0, resizeWidth, resizeHeight);
				canvas.toBlob((blob: Blob | null): void => {
					if (blob == null) {
						resolve(image);
					} else {
						const result = new File([blob], image.name, {
							type: image.type
						});
						resolve(result);
					}
				}, image.type);
			}
		);
	});
}

function asFile(image: Blob): File {
	if (image instanceof File) {
		return image;
	}

	return new File([image], "img", {
		type: image.type
	});
}
